class BESSAppAccountDetails extends BESSAppBase {

    constructor() {
        super();
        this.root = $('.app-account-details');
        if (this.root.length === 0) {
            return;
        }

        this.inputs = {
            email: getMaterialTextControl('email_details'),
            name: getMaterialTextControl('name_details'),
            organisation: getMaterialTextControl('org_details'),
            //industry: getMaterialTextControl('industry'),
            role: getMaterialTextControl('role'),
        }
        this.origEmail = this.inputs.email.attr('data-orig-email');
        this.warnEmail = $('.app-warn-email-confirm');

        this.updateBtn = this.root.find('.app-update');

        this.form = this.root.find('form');
        this.form.submit(this.#onUpdateUser.bind(this));

        let email = this.inputs.email.val().trim().toLowerCase();
        this.warnEmail.showIf(email !== this.origEmail);
    }

    #onUpdateUser(e) {
        e.preventDefault();

        this.updateBtn.disableControl();
        this.updateBtn.addClass('app-saving').removeClass('app-saved');

        let email = this.inputs.email.val().trim().toLowerCase();
        this.warnEmail.showIf(email !== this.origEmail);

        BESSApp.instance.services.api.auth.updateUser(
            email,
            this.inputs.name.val().trim(),
            this.inputs.organisation.val().trim(),
            null,
            this.inputs.role.val(),
            this.#onUpdated.bind(this),
        );
    }

    #onUpdated() {
        this.doDelayed(function () {

            this.updateBtn.enableControl();
            this.updateBtn.removeClass('app-saving').addClass('app-saved');
        }, 500);
    }
}
